import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

export default function RejectionModal({
    show,
    onClose,
    onReject,
    rejectionReason,
    setRejectionReason
}) {

    if (!show) return null;

    const handleReject = () => {
        onReject();
    };

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
                background: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(4px)",
                zIndex: 1200,
            }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                style={{ maxWidth: "500px", width: "90%" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="modal-content p-4 rounded-4 shadow"
                    style={{
                        background: "#fff",
                        borderRadius: "16px",
                        padding: "20px",
                        width: "100%",
                        maxWidth: "500px",
                    }}
                >
                    {/* Title */}
                    <h5
                        className="fw-bold mb-0"
                        style={{ color: "#0B1437", marginBottom: "8px" }}
                    >
                        Reject Application
                    </h5>
                    <hr />

                    {/* Description */}
                    <p
                        style={{
                            color: "#6B7280",
                            fontSize: "14px",
                            marginBottom: "20px",
                        }}
                    >
                        Are you sure you want to reject application? This action is permanent and can’t be restored.
                    </p>

                    {/* Textarea */}
                    <Form.Group className="mb-4">
                        <Form.Label
                            className="fw-semibold"
                            style={{ color: "#111827", fontSize: "14px" }}
                        >
                            Rejection reason
                        </Form.Label>

                        <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder="Type rejection reason..."
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            style={{
                                borderRadius: "10px",
                                border: "1.5px solid #D1D5DB",
                                resize: "none",
                            }}
                        />
                    </Form.Group>

                    {/* Buttons */}
                    <div className="d-flex  gap-3 ">

                        <Button
                            variant="outline-secondary"
                            className="px-4"
                            onClick={() => {
                                setRejectionReason("");
                                onClose();
                            }}
                            style={{
                                minWidth: "220px",
                                height: "44px",
                                borderRadius: "10px",
                                border: "1.5px solid #D1D5DB",
                                background: "#fff",
                                color: "#374151",
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            className="px-4"
                            style={{
                                backgroundColor: "#0B1437",
                                color: "#fff",
                                minWidth: "220px",
                                height: "44px",
                                borderRadius: "10px",
                                fontWeight: "600",
                            }}
                            onClick={handleReject}
                        >
                            Reject
                        </Button>

                    </div>
                </div>
            </div>
        </div>
    );
}
